const resetURL = () =>
  window.history.replaceState('', 'resetURL', 'http://localhost:1234/#edit');

export default resetURL;
